module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"sign_up":"Registrieren"},"en":{"sign_up":"Sign up"},"es":{"sign_up":"Regístrate"},"fr":{"sign_up":"S’inscrire"},"it":{"sign_up":"Registrati"},"ja":{"sign_up":"プライバシーポリシーに同意して登録する"},"pt":{"sign_up":"Registre-se"},"zh":{"sign_up":"注册"}}')
  delete Component.options._Ctor
}
